import { useState } from "react";
import toast from "react-hot-toast";

interface CustomAmountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (amount: number) => void;
}

export default function CustomAmountModal({
  isOpen,
  onClose,
  onSubmit,
}: CustomAmountModalProps) {
  const [amount, setAmount] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    const numAmount = parseFloat(amount);
    
    if (!amount || isNaN(numAmount)) {
      toast.error("Geçerli bir tutar girin");
      return;
    }

    if (numAmount < 10) {
      toast.error("Minimum destek tutarı 10 TL'dir");
      return;
    }

    if (numAmount > 50000) {
      toast.error("Maksimum destek tutarı 50.000 TL'dir");
      return;
    }

    onSubmit(numAmount);
    setAmount("");
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 20
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#0a0a0a",
          border: "1px solid #333",
          borderRadius: 16,
          maxWidth: 450,
          width: "100%",
          padding: 32
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{
          margin: 0,
          marginBottom: 8,
          fontSize: 24,
          fontWeight: 700,
          color: "#fff",
          textAlign: "center"
        }}>
          💰 Özel Destek Tutarı
        </h3>
        
        <p style={{
          margin: 0,
          marginBottom: 24,
          fontSize: 14,
          color: "#aaa",
          textAlign: "center"
        }}>
          Desteklemek istediğin tutarı belirle
        </p>

        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: "block",
            fontSize: 13,
            color: "#888",
            marginBottom: 8,
            fontWeight: 600
          }}>
            Destek Tutarı (TL)
          </label>
          
          <div style={{ position: "relative" }}>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Örn: 100"
              min="10"
              max="50000"
              step="1"
              autoFocus
              style={{
                width: "100%",
                background: "#1a1a1a",
                border: "2px solid #333",
                borderRadius: 8,
                padding: "14px 50px 14px 16px",
                fontSize: 18,
                fontWeight: 600,
                color: "#fff",
                outline: "none",
                transition: "all 0.3s",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = "#114232";
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = "#333";
              }}
            />
            <span style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 16,
              fontWeight: 600,
              color: "#114232",
              pointerEvents: "none"
            }}>
              TL
            </span>
          </div>

          <p style={{
            margin: 0,
            marginTop: 8,
            fontSize: 12,
            color: "#666"
          }}>
            Min: 10 TL • Max: 50.000 TL
          </p>
        </div>

        <div style={{
          background: "rgba(17, 66, 50, 0.1)",
          border: "1px solid rgba(17, 66, 50, 0.3)",
          borderRadius: 8,
          padding: 12,
          marginBottom: 24
        }}>
          <p style={{
            margin: 0,
            fontSize: 13,
            color: "#aaa",
            lineHeight: 1.5
          }}>
            ℹ️ Banka havalesi ile ödeme yapabilirsin. Her destek çok değerli! 💚
          </p>
        </div>

        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              background: "transparent",
              border: "1px solid #333",
              borderRadius: 8,
              padding: 14,
              color: "#aaa",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#555";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#333";
            }}
          >
            İptal
          </button>
          
          <button
            onClick={handleSubmit}
            style={{
              flex: 1,
              background: "linear-gradient(135deg, #114232 0%, #1a6b4f 100%)",
              border: "none",
              borderRadius: 8,
              padding: 14,
              color: "#fff",
              fontSize: 15,
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.3s"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(17, 66, 50, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Devam Et →
          </button>
        </div>
      </div>
    </div>
  );
}
